var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-top-nav",class:{
    'floating': _vm.model.isFloating,
    'nav-open': _vm.navOpen
  }},[_c('header',{staticClass:"c-header u-flex u-flex-justify-space-between"},[_c('BrandLogo',{staticClass:"c-header__logo",attrs:{"model":_vm.model.brandLogo}}),_c('div',{staticClass:"c-header__burger",on:{"click":_vm.onMenuClick}},[_c('BurgerMenu')],1)],1),_c('MainMenu',{attrs:{"model":_vm.model.mainMenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }